var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaceholderImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 93,
    viewBox: "0 0 78 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.9395 2.93225L75.4899 23.9177V68.034L38.9392 90.0433L1.85096 68.0267V23.9249L38.9395 2.93225Z",
    fill: "#D9DBE9",
    stroke: "#EFF0F7",
    strokeWidth: 3.50661
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9391 90.044L13.6936 75.081V30.3345L38.932 15.2981L63.396 30.3191V75.3357L38.9391 90.044Z",
    fill: "#D9DBE9",
    stroke: "#EFF0F7",
    strokeWidth: 3.50661
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6767 29.2626L52.0797 37.8084V81.9786L38.6838 90.0451L24.7787 81.834V37.826L38.6767 29.2626Z",
    fill: "#D9DBE9",
    stroke: "#EFF0F7",
    strokeWidth: 3.50661
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholderImage);
export default __webpack_public_path__ + "static/media/placeholder_image.a73dae7a31a1792c68fcfa7b14f0596e.svg";
export { ForwardRef as ReactComponent };